import React, { useEffect, useState } from "react";

import { useWorklogMissing } from "../../utils/reactQuery/worklogMissing";
import RemindMeLater from "./RemindMeLater";
import MissingWorklogList from "./MissingWorklogList";
import "./missingWorklog.scss";
import FormDialog from "../Dialog/FormDialog";

function WorklogMissing() {
  const { worklog, refetch, isRefetching } = useWorklogMissing();
  const { responseData, daily_worklog_hours } = worklog?.data?.data || {};
  const [dialog, setDialog] = useState(false);

  useEffect(() => {
    if (responseData && responseData?.length) setDialog(true);
    else setDialog(false);
  }, [responseData, isRefetching]);

  const handleClose = () => {
    setDialog(false);
  };
  return (
    <>
      {dialog && (
        <FormDialog
          open={dialog}
          title={"Worklog Missing"}
          showCrossIcon={false}
        >
          <MissingWorklogList
            list={responseData}
            daily_worklog_hours={daily_worklog_hours}
          />
          <RemindMeLater handleClose={handleClose} />
        </FormDialog>
      )}
    </>
  );
}

export default React.memo(WorklogMissing);
